import Vue from "vue";
import SaveButton from "@/components/button/SaveButton.vue";
import CancelButton from "@/components/button/CancelButton.vue";

Vue.component("SaveButton", SaveButton);
Vue.component("CancelButton", CancelButton);
